const options = {
    rootMargin: "30% 0px -70% 0px",
    threshold: 0.5, // half of item height
};

const cta = document.querySelector(".cta-floating");
const trigger = document.querySelector(".cta-floating-trigger");
let triggerElementPositions = new Array();
let isStuck = false;

const expand = () => {
    if (isStuck) return;
    cta.classList.add("stuck");
    cta.classList.add("collapsed");
    cta.style.top = window.innerHeight * 0.3 + "px";
    isStuck = true;
};

const collapse = () => {
    if (!isStuck) return;
    cta.classList.remove("stuck");
    cta.classList.remove("collapsed");
    cta.style.top = "";
    isStuck = false;
};

const observer = new IntersectionObserver((entries) => {
    const [{ isIntersecting }] = entries;

    triggerElementPositions.push(entries[0].boundingClientRect.y);
    let compareArray = triggerElementPositions.slice(
        triggerElementPositions.length - 2,
        triggerElementPositions.length
    );
    let down = compareArray[0] > compareArray[1] ? true : false;
    triggerElementPositions = compareArray;
    const viewportOffset = cta.getBoundingClientRect();
    const top = viewportOffset.top;
    const lastArrEl = compareArray.slice(-1);

    if (compareArray.length < 2 && lastArrEl < window.innerHeight * 0.3) {
        expand();
        return;
    }

    if (down && lastArrEl < 0) {
        expand();
        return;
    }

    if (isIntersecting) {
        expand();
    } else {
        collapse();
    }
}, options);

window.addEventListener(
    "load",
    () => {
        if (trigger && "IntersectionObserver" in window) observer.observe(trigger);
    },
    false
);

const ctaToggle = document.querySelector(".cta-toggle");
if (ctaToggle)
    ctaToggle.addEventListener("click", () => {
        //menu.classList.toggle("hidden");
        cta.classList.toggle("collapsed");
    });
